(function () {
  function initTabs(sectionId) {
    var sectionEl = document.querySelector('[data-pdp-tabs="' + sectionId + '"]');
    if (!sectionEl) return;

    var tabs = sectionEl.querySelectorAll('.pdp-product-tabs__tab');
    var panels = sectionEl.querySelectorAll('.pdp-product-tabs__panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var targetIndex = tab.dataset.tabIndex;

        tabs.forEach(function (t) { t.classList.remove('active'); });
        panels.forEach(function (p) { p.classList.remove('active'); });

        tab.classList.add('active');
        var targetPanel = sectionEl.querySelector('[data-panel-index="' + targetIndex + '"]');
        if (targetPanel) targetPanel.classList.add('active');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-pdp-tabs]').forEach(function (el) {
      initTabs(el.dataset.pdpTabs);
    });
  });

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-pdp-tabs]');
    if (el) initTabs(el.dataset.pdpTabs);
  });
})();
